import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import ThresholdsPage from "./routes/ThresholdsPage";

export default store => {
  return {
    path: "performance-thresholds",
    component: withAsyncRouteLoading(
      () =>
        Promise.all([
          import(
            /* webpackChunkName: "performance-thresholds" */ "./components"
          ),
        ]).then(([importedModule0]) => {
          const component = importedModule0.default;
          return component;
        })
      // .catch(err => {
      //   throw err;
      // })
    ),
    childRoutes: [ThresholdsPage(store)],
  };
};
